import React, {useEffect} from 'react'
import {IActiveSubscriptionModel} from '../../../models/partner-manage-model/IPackageModel'

type Props = {
  data: IActiveSubscriptionModel
}

const ExpAfterFiveDayCard: React.FC<Props> = ({data}) => {
  useEffect(() => {
    console.log('Use Effect Call')
    return () => {}
  }, [data])

  return (
    <>
      <tr key={data.packageID} className='text-start'>
        <td>
          <span className='text-dark text-hover-primary fs-6'>{data.partnerName}</span>
        </td>
        <td>
          <span className='text-dark text-hover-primary fs-6'>
            {data.packageName ? data.packageName : 'N.A'}
          </span>
        </td>
        <td>
          <span className='text-dark text-hover-primary fs-6'>
            {data.packageExpireDate === '01-Jan-1900' ? 'N.A' : data.packageExpireDate}
          </span>
        </td>
        <td>
          <span className='text-dark text-hover-primary d-block fs-6'>{data.durationDays}</span>
        </td>
        <td>
          <span className='text-dark text-hover-primary d-block fs-6'>{data.remainingDays}</span>
        </td>
        <td>
          <span className='text-dark text-hover-primary d-block fs-6'>{data.price}</span>
        </td>
      </tr>
    </>
  )
}

export {ExpAfterFiveDayCard}
